<template>
    <div class="thank-you-page">
        <div class='top'>
            <Header
                    :title="title"
                    :description="description"
                    :title-color="titleColor"
                    :description-color="descriptionColor"
                    :title-font-size="titleFontSize"
                    :description-font-size="descriptionFontSize"
            ></Header>
        </div>
        <div class="bottom">
            <div class="thank-you-message">
                <p class="thank-you-text" :style="{color: descriptionColor}">{{ thankYouText }}</p>
                      
                <div v-if="subscribe" class="subscribe-section">
                    <a :href="subscribe.url" target="_blank" class="submit-button subscribe-button">Subscribe To Newsletter</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SurveyHeader from './SurveyHeader'

export default {
    name: 'ThankYouPage',
    components: { SurveyHeader },
    props: ['title', 'titleColor', 'titleFontSize', 'description', 'descriptionColor', 'descriptionFontSize', 'thankYouText', 'subscribe'],
    methods: {}
}
</script>

<style>
    .thank-you-message {
        text-align: center;
    }

    .subscribe-section {
      text-align: center;
      padding-top: 20px;
    }

    .subscribe-button {
      text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// node_modules/survey-fields/src/Wrappers/ThankYouPage.vue